import React from 'react';
import PropTypes from 'prop-types';
import config from 'react-global-configuration';
import i18n from '../../i18n';

const getSupportUrl = () => {
  try {
    const supportUrl = new URL(config.get('contactUsUrl'));
    return supportUrl.protocol === 'https:' ? supportUrl.href : null;
  } catch {
    return null;
  }
};

class GlobalErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Global React error boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const supportUrl = getSupportUrl();

      return (
        <main className='global-error-boundary' role='alert' dir={i18n.dir()}>
          <div className='global-error-boundary__content'>
            <h1>{i18n.t('title.unexpectedError')}</h1>
            <p>{i18n.t('description.unexpectedError')}</p>
            <div className='global-error-boundary__actions'>
              <button
                className='global-error-boundary__primary-action'
                type='button'
                onClick={() => window.location.reload()}
              >
                {i18n.t('title.refresh')}
              </button>
              {supportUrl && (
                <a
                  className='global-error-boundary__support-action'
                  href={supportUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  referrerPolicy='no-referrer'
                >
                  {i18n.t('title.reportProblem')}
                </a>
              )}
            </div>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}

GlobalErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GlobalErrorBoundary;
